import { render, staticRenderFns } from "./UserEmailAddress.vue?vue&type=template&id=2356e258"
import script from "./UserEmailAddress.vue?vue&type=script&lang=js"
export * from "./UserEmailAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports